var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    staticClass: "mypage-navigation-container"
  }, [_c('ul', {
    staticClass: "mypage-navigation"
  }, [_c('li', {
    staticClass: "mypage-navigation__list"
  }, [_c('router-link', {
    staticClass: "mypage-navigation__link",
    attrs: {
      "to": "/mypage/myinfo",
      "exact-active-class": "",
      "active-class": "on"
    }
  }, [_c('span', [_vm._v("회원정보")])])], 1), _c('li', {
    staticClass: "mypage-navigation__list"
  }, [_c('router-link', {
    staticClass: "mypage-navigation__link",
    attrs: {
      "to": "/mypage/question",
      "exact-active-class": "",
      "active-class": "on"
    }
  }, [_c('span', [_vm._v("1:1 문의")])])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }